@for (banner of banners(); track banner) {
  <div class="banner" [class]="banner.type">
    @if (banner.icon) {
      <i class="material-symbols-outlined">{{ banner.icon }}</i>
    }
    <span>{{ banner.message }}</span>
  </div>
}
